exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".border,.fancyPicker .v-input__slot{border:1px solid rgba(0,0,0,.12) !important;border-color:rgba(0,0,0,.12) !important}.fancyPicker .v-input__slot{box-shadow:none !important}", ""]);
